import React from "react";
import { useNavigate } from "react-router-dom";

export default function MainMenu() {
    const navigate = useNavigate();

    return (
        <div
            className="mobile-intro-wrapper d-flex flex-column justify-content-center" 
            style={{
                background: "#F8F9FA",
                maxWidth: "600px",
                margin: "0 auto",
                width: "100%",
                minHeight: "100vh", 
                height: "auto",
                padding: "15px 24px",
            }}
        >
            
            <div className="d-flex flex-column gap-5 w-100">

                <div
                    onClick={() => navigate("/inspection/daily_check")}
                    className="bg-white p-4 d-flex align-items-center justify-content-between"
                    style={{
                        borderRadius: "20px",
                        cursor: "pointer",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.03)",
                        border: "1px solid #EAECEF",
                        transition: "all 0.2s",
                        minHeight: "110px" 
                    }}
                >
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center justify-content-center" style={{ background: "#EBF3FF", width: "60px", height: "60px", borderRadius: "14px" }}>
                            <img alt="" width="32" height="32" src={process.env.PUBLIC_URL + "/img/icon_application_off.png"} />
                        </div>
                        <span className="fw-bold text-dark" style={{fontSize : "16px"}}>점검표 작성하기</span>
                    </div>
                    <span className="text-muted fw-bold" style={{fontSize : "20px"}}>&gt;</span>
                </div>

                <div
                    onClick={() => navigate("/inspection/calendar")}
                    className="bg-white p-4 d-flex align-items-center justify-content-between"
                    style={{
                        borderRadius: "20px",
                        cursor: "pointer",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.03)",
                        border: "1px solid #EAECEF",
                        transition: "all 0.2s",
                        minHeight: "110px"
                    }}

                >
                    <div className="d-flex align-items-center gap-3">
                        <div className="d-flex align-items-center justify-content-center" style={{ background: "#EBF3FF", width: "60px", height: "60px", borderRadius: "14px" }}>
                            <img alt="" width="32" height="32" src={process.env.PUBLIC_URL + "/img/icon_registration_off.png"} />
                        </div>
                        <span className="fw-bold text-dark" style={{fontSize : "16px"}}>점검표 확인 / 내보내기</span>
                    </div>
                    <span className="text-muted fw-bold" style={{fontSize : "20px"}}>&gt;</span>
                </div>

            </div>
        </div>
    );
}